import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';

import RightArrow from '../../../images/icons/arrow-right.inline.svg';

const ContactInfoContainer = styled.div`
    .contact-info-wrapper {
        padding: 100px 0;
        text-align: center;
        ${media.medium`max-width: 800px;`}

        h2 {
            color: #000;
            font-size: 2.3rem;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
        }

        p {
            font-size: 1.1rem;
            color: #000;
        }
    }

    .btn-container {
        max-width: 350px;
        margin: 0px auto 0;
        padding: 20px 0 0;
        a {
            color: #fff;
            font-weight: bold;
            text-decoration: none;
            border: 1px solid #f74d33;
            font-size: 1.3rem;
            display: flex;
            align-items: center;
            background: #f74d33;
            box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
            border-radius: 5px;
            text-align: center;
            padding: 25px 20px;
            justify-content: space-between;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            ${TransitionMixin('.25s')}

            span {
                svg {
                    position: relative;
                    top: 4px;
                }
            }

            &:hover {
                background-color: #fff;
                color: #f74d33;

                span {
                    svg {
                        path {
                            fill: #f74d33;
                        }
                    }
                }
            }
        }
    }
`;

const ContactInfo = ({ info }) => {
    const { contactHeadline, contactButton, contactCaption } = info || {};
    return (
        <ContactInfoContainer>
            <Wrapper className="contact-info-wrapper">
                <h2>{contactHeadline}</h2>
                <p>{contactCaption}</p>
                <div className="btn-container">
                    {contactButton && (
                        <Link to={contactButton.url}>
                            {contactButton.title}{' '}
                            <span>
                                <RightArrow />
                            </span>
                        </Link>
                    )}
                </div>
            </Wrapper>
        </ContactInfoContainer>
    );
};

export default ContactInfo;
